export enum AuthorisationTypeEnum {
    Tailoring = 'Tailoring authorisation(s)',
    Cleaning = 'Cleaning authorisation(s)',
    Risk =  'Risk authorisation(s)',
    Minor_repair = 'Minor repair authorisation(s)',
    Leather =  'Leather authorisation(s)',

  }